import { IEmployeeState } from '@/store/employee';
import { IEmployeeMutations } from './mutations.types';
import {
  IEmployeeData,
  IEmployeeWorkScheduleData,
  IUserData,
  IHrDepartmentData
} from '@/models';

export const mutations: IEmployeeMutations = {
  SET_COUNT(state: IEmployeeState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IEmployeeState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IEmployeeState): void {
    state.count -= 1;
  },

  SET_EMPLOYEES(state: IEmployeeState, payload: IEmployeeData[]): void {
    state.employees = payload;
  },

  SET_SUPERVISOR_EMPLOYEES(
    state: IEmployeeState,
    payload: IEmployeeData[]
  ): void {
    state.supervisorEmployees = payload;
  },

  ADD_EMPLOYEE(state: IEmployeeState, payload: IEmployeeData): void {
    state.employees.push(payload);
  },

  UPDATE_EMPLOYEE(state: IEmployeeState, payload: IEmployeeData): void {
    const index = state.employees.findIndex(
      (account: IEmployeeData) => account.id === payload.id
    );

    state.employees.splice(index, 1, payload);
  },

  REMOVE_EMPLOYEE(state: IEmployeeState, payload: number): void {
    const index = state.employees.findIndex(
      (account: IEmployeeData) => account.id === payload
    );

    state.employees.splice(index, 1);
  },

  SET_EMPLOYEE_USERS(state: IEmployeeState, payload: IUserData[]): void {
    state.salaryEmployeeUsers = payload;
  },

  SET_LAST_PROMISE(state: IEmployeeState, payload: Promise<any>): void {
    state.lastPromise = payload;
  },

  SET_EMPLOYEE_WORK_SCHEDULE(
    state: IEmployeeState,
    payload: IEmployeeWorkScheduleData
  ): void {
    state.employeeWorkSchedule = payload;
  },

  REMOVE_EMPLOYEE_WORK_SCHEDULE(state: IEmployeeState): void {
    state.employeeWorkSchedule = null;
  },

  SET_EMPLOYEE_TEAM_DEPARTMENTS(
    state: IEmployeeState,
    payload: IHrDepartmentData[]
  ): void {
    state.employeeTeamDepartments = payload;
  }
};
